<app-header></app-header>
<div class="wrapper">
  <div class="detail-page cus-playing">
    <app-poster-simmer *ngIf="shimmerStatus.poster"></app-poster-simmer>
    <section class="video-detail" *ngIf="!shimmerStatus.poster">
      <div class="player" *ngIf="loading_player && videoDetail.videoStatus">
        <youtube-player
          height="100%"
          width="100%"
          *ngIf="providerType == 'youtube'"
          [videoId]="videoId"
          (ready)="savePlayer($event)"
          (change)="onStateChange($event)"
        ></youtube-player>
        <dailymotion
          (pause)="pauseDailyMotion()"
          (play)="playDailyMotion()"
          controls="true"
          height="100%"
          width="100%"
          *ngIf="providerType == 'daily_motion'"
          queue-autoplay-next="false"
          sharing-enable="false"
          autoplay="false"
          [video]="videoId"
          uiTheme="light "
        ></dailymotion>
        <div *ngIf="providerType == 'vimeo'" #vimeoVideoContainer></div>
      </div>
      <div *ngIf="!loading_player && !videoDetail" class="video-not-support">
        <img [src]="app_constant.BrowserNotSupported" />
        <h4>{{ "VIDEO_DETAIL.MESSAGE2" | translate }}</h4>
      </div>
      <div class="video" *ngIf="loading_player && videoDetail.bannerStatus">
        <app-content-subscription
          [videoDetail]="videoDetail"
        ></app-content-subscription>
      </div>

      <div class="video-content" *ngIf="videoDetail">
        <div class="container p-0">
          <div class="banner-content-box">
            <app-video-info
              [videoDetail]="videoDetail"
              [url]="encodeUrl"
              [public_id]="public_id"
            ></app-video-info>
          </div>
        </div>
      </div>

      <!-- <div class="video-content">
      <div class="container">
        <div class="banner-content-box">
          <div>
            <p class="active">TV Series - Action</p>
            <h1>{{ videoDetail?.name }}</h1>
            <h5>1 Season | 10 Episodes</h5>
            <p [innerHtml]="videoDetail?.description"></p>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn circle-btn" [ngClass]="{ favorite: videoDetail?.is_favorite == 'yes' }"
              (click)="favoriteVideo()">
              <span class="material-icons" *ngIf="videoDetail?.is_favorite == 'no'">favorite_border</span>
              <span class="material-icons" *ngIf="videoDetail?.is_favorite == 'yes'">favorite</span>
            </button>
            <button class="btn circle-btn">
              <span class="icon-forword"></span>
            </button>
            <button class="btn btn-light-bg">
              <span class="material-icons">notifications</span> Remind Me
            </button>
          </div>
        </div>
      </div>
    </div> -->
    </section>

    <app-grid-simmer *ngIf="shimmerStatus.relatedvideo"></app-grid-simmer>
    <section
      class="related-search provider-content"
      *ngIf="!shimmerStatus.relatedvideo && reletedShows?.length > 0"
    >
      <div class="container">
        <div class="section-head">
          <h2>{{ "VIDEO_DETAIL.RELATED_VIDEOS" | translate }}</h2>
        </div>
        <div class="custome-set row">
          <div class="series-box" *ngFor="let show of reletedShows">
            <app-grid [data]="show" [gridType]="'landscape'"></app-grid>
          </div>
        </div>
        <!-- <div class="record-not-available" *ngIf="reletedShows?.length ==0">
          <div class="text-center">
            <img src="assets/images/no-recoard-playlist.png">
          </div>
        </div> -->
      </div>
    </section>
  </div>
</div>
<app-footer></app-footer>
